import React from "react";

export const RefundPolicy = () => {
  return (
    <div className="space-y-6">
      <div className="bg-white p-6 rounded-lg shadow-md">
        <h2 className="text-2xl font-bold text-gray-900 mb-6">Возврат и обмен</h2>
        
        <div className="prose max-w-none">
          <section className="mb-8">
            <h3 className="text-xl font-semibold text-gray-800 mb-4">Общие положения</h3>
            <p className="text-gray-600 leading-relaxed mb-4">
              Данная политика возврата и обмена регулирует порядок возврата денежных средств 
              за услуги, оказываемые через цифровую платформу Reversia.ru.
            </p>
            <p className="text-gray-600 leading-relaxed">
              Мы стремимся обеспечить высокое качество предоставляемых услуг и готовы 
              рассмотреть обоснованные претензии заказчиков.
            </p>
          </section>

          <section className="mb-8">
            <h3 className="text-xl font-semibold text-gray-800 mb-4">Условия возврата</h3>
            <div className="bg-gray-50 p-4 rounded-lg mb-4">
              <h4 className="font-medium text-gray-800 mb-2">Возврат возможен в случаях:</h4>
              <ul className="list-disc pl-5 space-y-2 text-gray-600">
                <li>Исполнитель не выполнил задание в согласованные сроки</li>
                <li>Предоставленные материалы не соответствуют техническому заданию</li>
                <li>Нарушение условий безопасности при выполнении задания</li>
                <li>Отказ исполнителя от выполнения принятого задания</li>
              </ul>
            </div>
          </section>

          <section className="mb-8">
            <h3 className="text-xl font-semibold text-gray-800 mb-4">Сроки подачи заявления</h3>
            <div className="grid md:grid-cols-2 gap-6">
              <div className="bg-blue-50 p-4 rounded-lg">
                <h4 className="font-medium text-blue-800 mb-2">До завершения задания</h4>
                <p className="text-blue-700 text-sm">
                  Заявление может быть подано в любое время до подтверждения 
                  выполнения задания заказчиком.
                </p>
              </div>
              <div className="bg-orange-50 p-4 rounded-lg">
                <h4 className="font-medium text-orange-800 mb-2">После завершения</h4>
                <p className="text-orange-700 text-sm">
                  В течение 24 часов после подтверждения выполнения при 
                  обнаружении существенных недостатков.
                </p>
              </div>
            </div>
          </section>

          <section className="mb-8">
            <h3 className="text-xl font-semibold text-gray-800 mb-4">Процедура возврата</h3>
            <div className="space-y-4">
              <div className="flex items-start space-x-3">
                <div className="bg-blue-600 text-white rounded-full w-8 h-8 flex items-center justify-center text-sm font-medium">1</div>
                <div>
                  <h4 className="font-medium text-gray-800">Подача заявления</h4>
                  <p className="text-gray-600 text-sm mt-1">
                    Отправьте заявление на <a href="mailto:support@reversia.ru" className="text-blue-600 hover:underline">support@reversia.ru</a> 
                    с описанием проблемы и приложением подтверждающих материалов.
                  </p>
                </div>
              </div>
              
              <div className="flex items-start space-x-3">
                <div className="bg-blue-600 text-white rounded-full w-8 h-8 flex items-center justify-center text-sm font-medium">2</div>
                <div>
                  <h4 className="font-medium text-gray-800">Рассмотрение</h4>
                  <p className="text-gray-600 text-sm mt-1">
                    Администрация рассматривает заявление в течение 3 рабочих дней 
                    с момента получения.
                  </p>
                </div>
              </div>
              
              <div className="flex items-start space-x-3">
                <div className="bg-blue-600 text-white rounded-full w-8 h-8 flex items-center justify-center text-sm font-medium">3</div>
                <div>
                  <h4 className="font-medium text-gray-800">Решение</h4>
                  <p className="text-gray-600 text-sm mt-1">
                    При положительном решении возврат осуществляется в течение 5-10 рабочих дней.
                  </p>
                </div>
              </div>
            </div>
          </section>

          <section className="mb-8">
            <h3 className="text-xl font-semibold text-gray-800 mb-4">Особенности возврата</h3>
            <div className="bg-yellow-50 border border-yellow-200 p-4 rounded-lg">
              <p className="text-yellow-800 text-sm">
                <strong>Внимание:</strong> Комиссия платежной системы при возврате средств не возмещается. 
                Возврат осуществляется на тот же способ оплаты, который использовался при оплате услуги.
              </p>
            </div>
          </section>

          <section className="mb-8">
            <h3 className="text-xl font-semibold text-gray-800 mb-4">Задания от организаций (B2B)</h3>
            <div className="bg-blue-50 border border-blue-200 p-4 rounded-lg">
              <p className="text-blue-800 text-sm">
                Настоящая Политика применяется только к заданиям, оплаченным через Платформу (с резервированием средств).
                К заданиям от организаций (B2B-заданиям), расчёты по которым проводятся напрямую между Заказчиком и Исполнителем,
                Политика возвратов не применяется; вопросы возврата решаются сторонами самостоятельно в рамках заключённого между ними договора.
              </p>
            </div>
          </section>


          <section className="mb-6">
            <h3 className="text-xl font-semibold text-gray-800 mb-4">Контактная информация</h3>
            <div className="bg-gray-50 p-4 rounded-lg">
              <p className="text-gray-700">
                <strong>Email поддержки:</strong> <a href="mailto:support@reversia.ru" className="text-blue-600 hover:underline">support@reversia.ru</a>
              </p>
              <p className="text-gray-700 mt-2">
                <strong>Время работы:</strong> Пн-Пт: 9:00-18:00 (МСК)
              </p>
              <p className="text-gray-700 mt-2">
                <strong>Среднее время ответа:</strong> до 24 часов
              </p>
            </div>
          </section>
        </div>
      </div>
    </div>
  );
};

